import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex: auto;
    position: relative;

        .fill{
        min-width: 4rem;
    }

    .containerTextHome{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    
        height: 100%;
        width: 100%;
    }

    .textHome{
        font-size: 3rem;
        color:  #554842;
        text-align: center;
    }

  

    .purple{
        color: #7A05A7;
    }



    @media (max-width: 400px){
        .textHome{
            font-size: 2rem;
        }
    }

    @media (max-height: 538px){
        .textHome{
            font-size: 1.5rem;
        }
        .first{
            font-size: 0;
        }
    }

    @media (max-height: 464px){
        .textHome{
            font-size: 0;
        }
    }
`

export const Stars = styled.ul`
        li {
            list-style: none;
            position: absolute;

            &:before,
            &:after {
                content: '';
                position: absolute;
                background-color: #b4b2b2;
            }
            &:before {
                width: 10px;
                height: 2px;
                border-radius: 50%;
            }
            &:after {
                height: 8px;
                width: 2px;
                left: 4px;
                top: -3px;
            }

            &:last-child{
               opacity: 0.2;
               top: 60px
            }
            &:first-child {
                top: 100px;
                right: 40%;
                animation: twinkle 0.4s infinite;
            }
            &:nth-child(2) {
                top: 100;
                left: 30%;
                animation: twinkle 0.5s infinite;
                &:before {
                    height: 1px;
                    width: 5px;
                }
                &:after {
                    width: 1px;
                    height: 5px;
                    top: -2px;
                    left: 2px;
                    right: 20px;
                }
            }
            &:nth-child(3) {
                bottom: 300px;
                left: 30%;
                animation: twinkle 1s infinite;
            }
            &:nth-child(4) {
                bottom: 300px;
                right: 25%;
                animation: twinkle 0.5s ease infinite;
            }
            &:nth-child(5) {
                top: 200px;
                right: 25%;
                animation: twinkle 0.4s ease infinite;
            }
            &:nth-child(6) {
                top: 200px;
                left: 25%;
                animation: twinkle 0.2s infinite;
                &:before {
                    height: 1px;
                    width: 5px;
                }
                &:after {
                    width: 1px;
                    height: 5px;
                    top: -2px;
                    left: 2px;
                }
            }
        }
`



